import { GetLineResponse, InsertUpdateResponse, newCUstomer } from "../types/customer/apiRequestType";

export interface CustomerState {
    insertCustomerPending: boolean;
    insertCustomerSuccess: boolean;
    insertCustomerError: string | null;
    successInsert: false,
    messageInsert: '',

    deleteCustomerPending: boolean;
    deleteCustomerSuccess: boolean;
    deleteCustomerError: string | null;


    updateCustomerPending: boolean;
    updateCustomerSuccess: boolean;
    updateCustomerError: string | null;
    successUpdate: false,
    messageUpdate: '',

    changeNotificationCustomerPending: boolean;
    changeNotificationCustomerSuccess: boolean;
    changeNotificationCustomerError: string | null;

    getLineIdByCustomerIdPending: boolean;
    getLineIdByCustomerIdSuccess: boolean;
    getLineIdByCustomerIdError: string | null;
    lineInfo: GetLineResponse[],

    getQueueIdByCustomerIdPending: boolean;
    getQueueIdByCustomerIdSuccess: boolean;
    getQueueIdByCustomerIdError: string | null;
    queueInfo: GetLineResponse[]

}

//Insert ****************************************************************************
export interface InsertCustomerRequestPayload {
    params: newCUstomer
}
export interface InsertCustomerSuccessPayload {
    params: InsertUpdateResponse
}
export interface InsertCustomerErrorPayLoad {
    error: string
}

//remove*******************************************************************************

export interface deleteCustomerErrorPayLoad {
    error: string
}
//update******************************************************************************
export interface UpdateCustomerRequestPayload {
    params: newCUstomer
}
export interface UpdateCustomerSuccessPayload {
    params: InsertUpdateResponse
}
export interface UpdateCustomerErrorPayLoad {
    error: string
}
//Change notification********************************************************************

export interface ChangeNotificationCustomerRequestPayload {
    list: customerMembers[]
}
export interface ChangeNotificationCustomerSuccessPayload {

}
export interface ChangeNotificationCustomerErrorPayLoad {
    error: string
}
//get line id by customer id*************************************************************
export interface getCallTransferCustomerLineByCustomerMemberRequestPayload {
    Id: string
}
export interface getCallTransferCustomerLineByCustomerMemberSuccessPayload {
    params: GetLineResponse[]
}
export interface getCallTransferCustomerLineByCustomerMemberErrorPayLoad {
    error: string
}
//get line id by customer id*************************************************************
export interface getCallTransferCustomerQueueBySuccessPayload {
    params: GetLineResponse[]
}
export interface getCallTransferCustomerQueueByErrorPayLoad {
    error: string
}





export class CustomerMember {
    list: customerMembers[] = []
    isAllowUseSipExtension: boolean = false


    mapper(response: any) {
        let tempList: customerMembers[] = [];
        this.isAllowUseSipExtension = response?.isAllowUseSipExtention;
        response?.customerMembers?.forEach((item: any) => {
            tempList.push({
                Id: item.id,
                CustomerId: item.customerId,
                FirstName: item.firstName,
                LastName: item.lastName,
                Position: item.position,
                Mobile: item.mobile,
                Phone: item.phone,
                Email: item.email,
                IsOwner: item.isOwner,
                PhoneContactInfoId: item.phoneContactInfoId,
                IsCreditRanOutNotifReceiver: item.isCreditRanOutNotifReceiver,
                IsPackageExpiredNotifReceiver: item.isPackageExpiredNotifReceiver,
                // FullInfoPhone: item.fullInfoPhone,
                // FullInfoMobile: item.fullInfoMobile,
                SipPassword: item.sipPassword,
                SipExtention: item.sipExtention,
                CustomerLineId: item.customerLineId,
                InternalMobile: item.internalMobile,
                InternalPhone: item.internalPhone
            })
        })
        this.list = tempList;
    }
}

export interface customerMembers {
    Id: string | null
    CustomerId: string | null,
    FirstName: string | null,
    LastName: string | null,
    Position: null | null,
    Mobile: string | null,
    Phone: string | null,
    Email: string | null,
    IsOwner: boolean | null,
    PhoneContactInfoId: number | null,
    IsCreditRanOutNotifReceiver: boolean | null,
    IsPackageExpiredNotifReceiver: boolean | null,
    // FullInfoPhone: string | null,
    // FullInfoMobile: string | null,
    SipPassword: string | null,
    SipExtention: string | null,
    CustomerLineId: string | null,
    InternalPhone: string | null,
    InternalMobile: string | null
}




export interface IMemberShipItem {
    id: string,
    name: string
}

export class IGetCustomerMemberMemberShips {
    queuesName: IMemberShipItem[] = [];
    ivrLine: IMemberShipItem[] = [];
    secretaryLine: IMemberShipItem[] = []

    constructor(response: any) {
        if (response) {
            let queuesName: IMemberShipItem[] = [];
            let ivrLine: IMemberShipItem[] = [];
            let secretaryLine: IMemberShipItem[] = []

            response.queuesName?.forEach((queue: any) => {
                queuesName.push({
                    id: queue.id,
                    name: queue.name
                });
            });


            response.ivrLine?.forEach((ivr: any) => {
                ivrLine.push({
                    id: ivr.id,
                    name: ivr.name
                });
            });


            response.secretaryLine?.forEach((secretaryL: any) => {
                secretaryLine.push({
                    id: secretaryL.id,
                    name: secretaryL.name
                });
            });
            this.queuesName = queuesName;
            this.ivrLine = ivrLine;
            this.secretaryLine = secretaryLine

        }
    }
}